/**
 * KALICI DEPOLAMA UYARISI — "Yedeğinizi almadan veri girmeyin" (Ayarlar).
 *
 * Gelen karar 02.11.2026 (`claude/notlar/2026-11-02-kalici-depolama-uyarisi-kararlar.md`):
 * depolama kalıcı değilse görünür; bulut depolama seçili ve BAĞLIYKEN
 * görünmez (kasanın şifreli kopyası her değişiklikte yazılıyor); bağlantı
 * tamamlanmamış ya da kopmuşsa görünür. Elle şifreli yedek alındıysa ve kasa
 * o yedekten beri değişmediyse de görünmez.
 *
 * Bu uyarı bir zamanlar "şifreli yedekleme henüz yok, Aşama 4'te gelecek"
 * diyordu. `.pfai` geldiğinde metin güncellenmediği için arayüz kendi
 * özelliğini yok saydı — kodla metnin ayrışması bu projede tekrar eden kusur
 * türü. Kalan tek gerçek risk depolamanın kalıcı olmaması; uyarı yalnızca
 * onu söylüyor.
 */

import { useCallback } from "react";
import { M } from "../dil";
import { ELLE_YEDEK_AYARI, elleYedekOzeti } from "../lib/elleYedek";
import { useRepositoryContext } from "../repo/RepositoryContext";
import { useAsync } from "../repo/useAsync";
import { Notice } from "../ui/primitives";
import { useYedek } from "../yedek/YedekSaglayici";

export function KaliciDepolamaUyarisi() {
  const { repo, info, revision } = useRepositoryContext();
  const yedek = useYedek();
  const bulutBagli =
    yedek !== null && yedek.durum.kurulu === true && !yedek.durum.baglantiGerekli && yedek.durum.hata === null;
  const elleYedekLoad = useCallback(async (): Promise<boolean> => {
    const kayitli = await repo.settings.get(ELLE_YEDEK_AYARI);
    if (kayitli === null) return false;
    return kayitli === (await elleYedekOzeti(await repo.exportPlainJson()));
  }, [repo]);
  const elle = useAsync(elleYedekLoad, [repo, revision]);
  if (info.persistent || bulutBagli || elle.state.data === true) return null;
  return (
    <Notice tone="warn" title={M.ayarlar.kaliciUyari.baslik}>
      <p>
        <strong>{M.ayarlar.kaliciUyari.kaliciDegil}</strong> <code>navigator.storage.persist()</code>
        {M.ayarlar.kaliciUyari.persistOnce}
        <strong>false</strong>
        {M.ayarlar.kaliciUyari.persistSonra}
      </p>
      <p>
        {M.ayarlar.kaliciUyari.yuzdenOnEk}
        <strong>{M.ayarlar.kaliciUyari.depolama}</strong>
        {M.ayarlar.kaliciUyari.bolumunden}
        <strong>{M.ayarlar.kaliciUyari.bulutDepolama}</strong>
        {M.ayarlar.kaliciUyari.secinYaDa}
        <strong>{M.ayarlar.kaliciUyari.sifreliYedek}</strong>
        {M.ayarlar.kaliciUyari.sonEk}
      </p>
    </Notice>
  );
}
